// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-header-no-spacing-defined {
  padding-left: 20px;
  padding-top: 16px;
  padding-right: 20px;
}

.bolt-header-condensed {
  padding-top: 8px;
  padding-bottom: 8px;
}

.bolt-header-default {
  padding-top: 16px;
  padding-bottom: 16px;
}

.bolt-header-relaxed {
  padding-top: 24px;
  padding-bottom: 24px;
}

.bolt-header-with-commandbar.bolt-header-condensed {
  padding-right: 12px;
}

.bolt-header-with-commandbar.bolt-header-default {
  padding-right: 16px;
}

.bolt-header-with-commandbar.bolt-header-relaxed {
  padding-right: 28px;
}

.bolt-header-with-commandbar {
  padding-right: 16px;
}
@media screen and (max-width: 599px) {
  .bolt-header-with-commandbar {
    padding-right: 20px;
  }
}

.bolt-header-with-back-button {
  padding-left: 16px;
}
@media screen and (max-width: 599px) {
  .bolt-header-with-back-button {
    flex-direction: column;
    padding-left: 20px;
  }
}

.bolt-header-title-area {
  flex-shrink: 25;
}

.bolt-header-content-area {
  min-width: 0px;
}
@media screen and (max-width: 599px) {
  .bolt-header-content-area {
    flex-wrap: wrap;
  }
}

.bolt-header-title {
  padding-top: 4px;
  padding-bottom: 4px;
}
.bolt-header-title.l {
  padding-top: 0px;
  padding-bottom: 0px;
}
.bolt-header-title.s {
  padding-top: 6px;
  padding-bottom: 6px;
}
.bolt-header-title {
  margin-right: 8px;
}
@media screen and (max-width: 599px) {
  .bolt-header-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.bolt-header-icon {
  font-size: 1rem;
  margin-right: 8px;
  margin-top: 8px;
}
.bolt-header-icon.l {
  margin-top: 10px;
}
.bolt-header-icon.s {
  margin-top: 6px;
}

.bolt-header-separator {
  height: 1px;
  background-color: rgba( 244, 244, 244 ,  1 );
  background-color: rgba( var(--palette-neutral-4,244, 244, 244) ,  1 );
}

.bolt-button.bolt-header-back-button {
  background-color: transparent;
  font-size: 1rem;
  margin-right: 8px;
}
@media screen and (max-width: 599px) {
  .bolt-button.bolt-header-back-button {
    padding: 0px;
  }
  .bolt-button.bolt-header-back-button .bolt-button-text {
    font-size: 0.75rem;
    color: rgba(0, 0, 0, .55);
    color: var(--text-secondary-color,rgba(0, 0, 0, .55));
    font-weight: normal;
  }
}

/*# sourceMappingURL=Header.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Header/Header.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Header/Header.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAIA;EACI,kBC4TS;ED3TT,iBCuTS;EDtTT,mBC0TS;AC7Tb;;AFMA;EACI,gBC0SQ;EDzSR,mBCySQ;AC5SZ;;AFMA;EACI,iBC6SS;ED5ST,oBC4SS;AC/Sb;;AFMA;EACI,iBG+EuB;EH9EvB,oBG8EuB;ADjF3B;;AFMA;EACI,mBAAA;AEHJ;;AFMA;EACI,mBAAA;AEHJ;;AFMA;EACI,mBAAA;AEHJ;;AFMA;EAMI,mBAAA;AERJ;AD6TI;ED3TJ;IASQ,mBCmRK;EC1RX;AACF;;AFUA;EACI,kBAAA;AEPJ;ADoTI;ED9SJ;IAIQ,sBAAA;IACA,kBC0QK;EChRX;AACF;;AFSA;EACI,eAAA;AENJ;;AFSA;EACI,cAAA;AENJ;ADsSI;EDjSJ;IAIQ,eAAA;EELN;AACF;;AFQA;EACI,gBCyOQ;EDxOR,mBCwOQ;AC7OZ;AFOI;EACI,gBAAA;EACA,mBAAA;AELR;AFQI;EACI,gBAAA;EACA,mBAAA;AENR;AFLA;EAcI,iBCgOQ;ACtOZ;ADiRI;EDzRJ;IAkBQ,mBAAA;IACA,gBAAA;IACA,uBAAA;EENN;AACF;;AFSA;EACI,eC8KS;ED7KT,iBCoNQ;EDnNR,eCmNQ;ACzNZ;AFQI;EACI,gBAAA;AENR;AFSI;EACI,eAAA;AEPR;;AFWA;EACI,WAAA;EACA,4CCvBQ;ECeV,qEAAqE;AACvE;;AAEA;EFUI,6BC0JS;EDzJT,eCgMQ;ECxMV,iBAAiB;ADmPf;ACjPJ;EACE;IACE,YAAY;EFSR;EEPN;IFSU,kBCqCK;IDpCL,yBCgKO;ICvKf,qDAAqD;IACrD,mBAAmB;EACrB;AACF;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
